import React, { useEffect, useState } from 'react';
import _css from "pages/home/Home.module.scss";
import { Carousel } from "react-responsive-carousel";
import LazyLoad from 'react-lazyload';
import { QUERY_IMAGES_CAROUSEL } from "services/urls";

interface Image {
    //props: React.ReactNode;
    id: number;
    public_url: string;
    description: string;
}


export const ImagesCarousel:React.FC = () => {

    const [images, setImages] = useState<Image[]>([]);;
    //const [loading, setLoading] = useState(true);
    const [itemCount, setItemCount] = useState(0);

    async function getImagesCarousel() {
        const url = QUERY_IMAGES_CAROUSEL;
        const headers = {
            'accept': 'application/json',
        };
        try {
            const response = await fetch(url, { method: 'GET', headers: headers, cache: 'no-store' });
            if(!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            const result = await response.json();
            setItemCount(result.length); // Count the items
            setImages(result || []); // Ensure data is an array, even if API returns null
        } catch(e) {
            console.error("There was an error!", e);
        }
    }

    useEffect(() => {
        getImagesCarousel();
    }, []);

    if(images) {
        if(itemCount > 0) {
            return (<div>
                    <Carousel className={_css.caroussel} showArrows={true} renderArrowPrev={() => { return <div></div> }} autoPlay infiniteLoop interval={15000} showStatus={false} showThumbs={false}>
                            {images.map((item: Image) => (
                            <div key={item.id}>
                                <LazyLoad resize height={'100%'}>
                                    <img alt={item.description} src={item.public_url} title={item.description} />
                                </LazyLoad>
                                {item.description ? (
                                    <p className="legend">{item.description}</p>
                                ) : null}   
                            </div>
                            ))}
                    </Carousel>
                </div>
            );
        }
        else {
            return null
        }
    } else {
        return <p>Loading...</p>;
    }
/*
  if (loading) return <p>Loading images...</p>;
    return (
                            <Carousel className={_css.caroussel} showArrows={true} renderArrowPrev={() => { return <div></div> }} autoPlay infiniteLoop interval={15000} showStatus={false} showThumbs={false}>
                                 {imagesCarousel && Array.isArray(imagesCarousel) ? (
                                    imagesCarousel.map(item => (
                                    <div key={item.id}>
                                    <LazyLoad resize height="{'100%'}">
                                        <img alt="{item.description}" src="{item.public_url}" />
                                    </LazyLoad>
                                    </div>
                                ))) : (
                                        <p>No data available or data is not an array.</p>
                                        )}

                                <div className={_css.image_slides}>
                                    <LazyLoad resize height={'100%'}>
                                        <img alt="img1" src="https://bap.s3.eu-de.cloud-object-storage.appdomain.cloud/bap-compressed/-BBQ_5780%20groupe.jpg" />
                                    </LazyLoad>
                                </div>
                                <div className={_css.image_slides}>
                                    <LazyLoad resize height={'100%'}>
                                        <img alt="img2" src="https://bap.s3.eu-de.cloud-object-storage.appdomain.cloud/bap-compressed/ABA_40W1153.jpg" />
                                    </LazyLoad>
                                </div>
                                <div className={_css.image_slides}>
                                    <LazyLoad resize height={'100%'}>
                                        <img alt="img3" src="https://bap.s3.eu-de.cloud-object-storage.appdomain.cloud/bap-compressed/BBQ_5796.jpg" />
                                    </LazyLoad>
                                </div>
                                <div className={_css.image_slides}>
                                    <LazyLoad resize height={'100%'}>
                                        <img alt="img4" src="https://bap.s3.eu-de.cloud-object-storage.appdomain.cloud/bap-compressed/BBQ_B40W5774.jpg" />
                                    </LazyLoad>
                                </div>
                                <div className={_css.image_slides}>
                                    <LazyLoad resize height={'100%'}>
                                        <img alt="img5" src="https://bap.s3.eu-de.cloud-object-storage.appdomain.cloud/C2_40W1344.jpg" />
                                    </LazyLoad>
                                </div>
                            </Carousel>

    )
                            */
}